FamilycardsImageLibrary.controller('editThemeController', [ '$scope', '$http', '$timeout', 'Upload', function( $scope, $http, $timeout ,Upload ) {

	$scope.themePreview = {};
	$scope.editThemeForm = {};

    $scope.uploadThemePreview = function(file, errFiles) {

        $scope.f = file;
        $scope.errFile = errFiles && errFiles[0];

        if (file) {

        	$scope.themePreview.is_uploading = true;

            file.upload = Upload.upload({
                url: api_url_upload_impression,
                data: {
                	image: file,
                	theme_preview: true,
                }
            });

            file.upload.then(function (response) {
            	$timeout(function() {
					initPopup();
				});
            	$scope.themePreview.is_uploading = false;
            	$scope.themePreview.file_name = $scope.f.name;
            	$scope.themePreview.url = response.data.file_url;

            }, function (response) {
                if (response.status > 0)
                    $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
        } 
    }

	$scope.setThemePreview = function( $url, $filename ) {
		$scope.themePreview = {
			url: $url,
			file_name: $filename
		}
	}

	$scope.deleteThemePreview = function( themePreview ) {
		var r = confirm("Weet je zeker dat je deze theme preview wilt verwijderen?");
		if (r == true) {
		   
			themePreview.is_deleting = true;

			$http({
				method: 'GET',
				url: api_url_delete_impression,
			}).
			success( function( data, status, headers, config ) {
				if( data == true ) {
					themePreview.is_deleting = false;
					themePreview.file_name = false;
				}
			}).
			error(function(data, status, headers, config) {});

		}

	}

	$scope.setCheckboxTrueValue = function( $field ) {
		$scope.editThemeForm[$field] = true;
	}

}]);